/**
 * Reveal elements based on scroll depth.
 *
 * Elements must have attribute:
 *   dla-trigger-scroll-depth="50"
 * and be initially hidden with class "d-none".
 *
 * When the scroll percentage is reached:
 *   - "d-none" is removed
 *   - "animate__animated animate__fadeIn" are added
 */
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.dlaScrollDepthReveal = {
    attach(context) {
      // Make sure we only set this up once.
      once('dlaScrollDepthRevealInit', 'body', context).forEach(function () {
        var $window = $(window);
        var $elements = $('[dla-trigger-scroll-depth]');

        if (!$elements.length) {
          return;
        }

        function getScrollPercent() {
          var scrollTop = $window.scrollTop();
          var docHeight = $(document).height();
          var winHeight = $window.height();
          var scrollable = docHeight - winHeight;

          if (scrollable <= 0) {
            return 100;
          }

          return (scrollTop / scrollable) * 100;
        }

        function checkScrollDepth() {
          var percent = getScrollPercent();

          $elements.each(function () {
            var $el = $(this);

            // Skip if already triggered.
            if ($el.data('dlaScrollTriggered')) {
              return;
            }

            var required = parseFloat($el.attr('dla-trigger-scroll-depth')) || 0;

            if (percent >= required) {
              $el
                .removeClass('d-none')
                .addClass('animate__animated animate__fadeIn');

              $el.data('dlaScrollTriggered', true);
            }
          });
        }

        // Initial check (in case user loads midway down).
        checkScrollDepth();

        // Update on scroll and resize.
        $window.on('scroll.dlaScrollDepthReveal resize.dlaScrollDepthReveal', checkScrollDepth);
      });
    }
  };

})(jQuery, Drupal, once);
